<template lang="pug">
  swiper(ref="homepageSwiper" :options="swiperOptions" data-slideout-ignore)
    swiper-slide(v-for="slide in slides" :key="slide.id")
      a(:href="slide.url")
        img.d-lg-block.d-none(:src="slide.desktop_image.url" v-if="slide.desktop_image")
        img.d-lg-none.d-block(:src="slide.mobile_image.url" v-if="slide.mobile_image")
    .swiper-pagination(slot="pagination")
</template>

<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import { RepositoryFactory } from '../../repositoryFactory';

const PageRepository = RepositoryFactory.get('page');

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        autoplay: {
          delay: 3000,
        },
      },
      slides: [],
    };
  },
  computed: {
    swiper() {
      return this.$refs.homepageSwiper.$swiper;
    },
  },
  mounted() {
    this.getSlideshows();
  },
  methods: {
    async getSlideshows() {
      const { data } = await PageRepository.homepage().slideshows().then((resp) => resp.data);
      this.slides = data;
    },
  },
};
</script>
